import { useEffect, useState } from 'react'
import { gradeDoMes, inicioDaSemana, parseDayKey, primeiroDoMes, somarDias, somarMeses } from './calendario.ts'

const MES_FMT = new Intl.DateTimeFormat('pt-BR', { month: 'long', year: 'numeric' })
const DIA_FMT = new Intl.DateTimeFormat('pt-BR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
const INICIAIS = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S']

const capitalizar = (texto: string) => texto.charAt(0).toUpperCase() + texto.slice(1)

/**
 * Mini calendário do explorer (design do calendário, 2026-10-31): navega o
 * mês sozinho, marca hoje (cheio) e o dia escolhido (claro) e, na exibição
 * Semana, pinta a semana inteira. Clicar num dia leva o calendário até ele.
 */
export function MiniCalendario({
  selecionado,
  hoje,
  semanaInteira,
  onEscolher,
}: {
  selecionado: string
  hoje: string
  /** Destacar a semana do dia escolhido (exibição Semana). */
  semanaInteira: boolean
  onEscolher: (dia: string) => void
}) {
  const [mes, setMes] = useState(() => primeiroDoMes(selecionado))

  // o calendário andou (setas, "Hoje", atalho): o mini acompanha
  useEffect(() => setMes(primeiroDoMes(selecionado)), [selecionado])

  const inicioDaSemanaEscolhida = inicioDaSemana(selecionado)
  const fimDaSemanaEscolhida = somarDias(inicioDaSemanaEscolhida, 6)

  return (
    <div className="cal-mini">
      <div className="cal-mini__head">
        <span className="cal-mini__title">{capitalizar(MES_FMT.format(parseDayKey(mes)))}</span>
        <button type="button" className="cal-round" aria-label="Mês anterior" onClick={() => setMes(somarMeses(mes, -1))}>
          <i className="fas fa-chevron-left" aria-hidden />
        </button>
        <button type="button" className="cal-round" aria-label="Próximo mês" onClick={() => setMes(somarMeses(mes, 1))}>
          <i className="fas fa-chevron-right" aria-hidden />
        </button>
      </div>
      <div className="cal-mini__grid" role="grid" aria-label={capitalizar(MES_FMT.format(parseDayKey(mes)))}>
        {INICIAIS.map((letra, i) => (
          <span key={i} className="cal-mini__dow" aria-hidden>
            {letra}
          </span>
        ))}
        {gradeDoMes(mes).map((dia) => {
          const naSemana = semanaInteira && dia >= inicioDaSemanaEscolhida && dia <= fimDaSemanaEscolhida
          return (
            <button
              key={dia}
              type="button"
              className={[
                'cal-mini__day',
                dia.slice(0, 7) !== mes.slice(0, 7) ? 'cal-mini__day--fora' : '',
                naSemana ? 'cal-mini__day--semana' : '',
                dia === selecionado ? 'cal-mini__day--sel' : '',
                dia === hoje ? 'cal-mini__day--hoje' : '',
              ]
                .filter(Boolean)
                .join(' ')}
              aria-pressed={dia === selecionado}
              aria-current={dia === hoje ? 'date' : undefined}
              aria-label={capitalizar(DIA_FMT.format(parseDayKey(dia)))}
              onClick={() => onEscolher(dia)}
            >
              <span>{Number(dia.slice(8, 10))}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
